var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "waiting-purchase-detail"
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("span", [_vm._v("核单详情")]),
        _vm._v(" "),
        _c("span", { staticClass: "light-color" }, [
          _vm._v(_vm._s(_vm.routeParams.supply_name))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "light-color" }, [
          _vm._v(_vm._s(_vm.routeParams.pgname))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm._v("\n    档口凭证：\n    "),
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: _vm.action,
                multiple: true,
                "show-file-list": true,
                accept: "'.jpg,.jpeg,.png,.JPG,.JPEG,.PBG'",
                "on-success": _vm.docUploaded,
                "list-type": "picture-card",
                "on-preview": _vm.preview,
                "on-remove": _vm.docRemove,
                "with-credentials": ""
              }
            },
            [_c("el-button", { staticClass: "linear" }, [_vm._v("上传凭证")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "splice-line" }),
      _vm._v(" "),
      _c(
        "el-tabs",
        { attrs: { type: "border-card", value: _vm.tabs[0].key } },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                name: _vm.tabs[0].key,
                label: _vm.tabs[0].name + "(" + _vm.calcTotalMap.total_num + ")"
              }
            },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入货号/款号/商品名" },
                    model: {
                      value: _vm.search_val,
                      callback: function($$v) {
                        _vm.search_val = $$v
                      },
                      expression: "search_val"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.getGoodsList }
                    },
                    [_vm._v("搜 索")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticClass: "goods-table",
                  attrs: {
                    data: _vm.goods_data.list,
                    "span-method": _vm.kdTableSpan,
                    border: "",
                    "max-height": "700"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "商品图片", align: "center", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  { name: "viewer", rawName: "v-viewer" }
                                ],
                                staticClass: "image-box"
                              },
                              _vm._l(scope.row.imgs, function(img, index) {
                                return _c("img", {
                                  key: index,
                                  staticClass: "viewer-img",
                                  attrs: { src: img }
                                })
                              }),
                              0
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                class:
                                  scope.row.activity_goods == 2
                                    ? "red-font"
                                    : ""
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.goods_name))
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v("-")]),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(scope.row.goods_no))])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "款号", align: "center", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              on: {
                                focus: function($event) {
                                  _vm.old_kh = scope.row.goods_kh
                                },
                                blur: function($event) {
                                  return _vm.changeKh(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.goods_kh,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "goods_kh", $$v)
                                },
                                expression: "scope.row.goods_kh"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "整款改价", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { size: "small" },
                              on: {
                                blur: function($event) {
                                  return _vm.changeGoodsPrice(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.new_goods_price,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "new_goods_price", $$v)
                                },
                                expression: "scope.row.new_goods_price"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "SKU改价", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { size: "small" },
                              on: {
                                blur: function($event) {
                                  return _vm.changeSkuPrice(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.new_sku_price,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "new_sku_price", $$v)
                                },
                                expression: "scope.row.new_sku_price"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "代采单价",
                      prop: "plan_price",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.plan_price) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "strike",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.remove_price,
                                    expression: "scope.row.remove_price"
                                  }
                                ]
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.remove_price) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "颜色", prop: "co_val", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "尺码", prop: "si_val", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "选择开单", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "full",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        return _vm.cgDialog(scope.row.goods_no)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.cg_num) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "剩余数量",
                      prop: "plan_num",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "full",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        return _vm.cgDialog(scope.row.goods_no)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.calcLeftNum(scope.row)) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "前置数量",
                      prop: "dk_num",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.calcDkNum(scope.row)) +
                                  "\n              "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "实付金额小计",
                      align: "center",
                      width: "180"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _c("div", [_vm._v("开单")]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(scope.row.total_num) + "件")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("¥" + _vm._s(scope.row.total_price))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "light-color" }, [
                                _vm._v(
                                  "\n                活动费¥" +
                                    _vm._s(scope.row.activity_fee) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "light-color" }, [
                                _vm._v(
                                  "\n                平台佣金¥" +
                                    _vm._s(scope.row.service_fee) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "light-color" }, [
                                _vm._v(
                                  "\n                小店佣金¥" +
                                    _vm._s(
                                      scope.row.dispense_commission_amount
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "light-color" }, [
                                _vm._v(
                                  "\n                退货服务费¥" +
                                    _vm._s(scope.row.refund_service_fee) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "blue-font pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.showBillingDetail(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                >>>\n              "
                                  )
                                ]
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      fixed: "right",
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.billing_info.is_sample_plan,
                                    expression: "!billing_info.is_sample_plan"
                                  }
                                ]
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "140px" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    size: "small",
                                    placeholder: "选择日期"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.setGoodsReturnDay(
                                        $event,
                                        scope.row
                                      )
                                    }
                                  },
                                  model: {
                                    value: scope.row.goods_return_day,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "goods_return_day",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.goods_return_day"
                                  }
                                }),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                scope.row.is_multi_phase
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "multi-phase-btn",
                                        attrs: { size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showMultiGoods(
                                              scope.row.goods_no
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                有多期\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "space-between span-top yellow-background" },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.resetAllCgNum }
                        },
                        [_vm._v("\n            重置数量")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.setAllCgNum }
                        },
                        [_vm._v("\n            全选")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n          实付金额合计：共" +
                        _vm._s(_vm.calcTotalMap.total_goods) +
                        "款，" +
                        _vm._s(_vm.calcTotalMap.total_num) +
                        "件，记¥" +
                        _vm._s(_vm.calcTotalMap.total_price) +
                        "\n        "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.billing_info.can_stop_goods
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: _vm.tabs[1].key,
                    label:
                      _vm.tabs[1].name + "(" + _vm.calcTotalMap.stop_num + ")"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { placeholder: "请输入货号/款号/商品名" },
                        model: {
                          value: _vm.search_val,
                          callback: function($$v) {
                            _vm.search_val = $$v
                          },
                          expression: "search_val"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.getGoodsList }
                        },
                        [_vm._v("搜 索")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.goods_data.list,
                        border: "",
                        "span-method": _vm.dhTableSpan,
                        "max-heigth": "700"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "商品图片",
                          align: "center",
                          width: "100"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        { name: "viewer", rawName: "v-viewer" }
                                      ],
                                      staticClass: "image-box"
                                    },
                                    _vm._l(scope.row.imgs, function(
                                      img,
                                      index
                                    ) {
                                      return _c("img", {
                                        key: index,
                                        staticClass: "viewer-img",
                                        attrs: { src: img }
                                      })
                                    }),
                                    0
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2131829567
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "商品名称", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      class:
                                        scope.row.activity_goods == 2
                                          ? "red-font"
                                          : ""
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.goods_name))
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [_vm._v("-")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.goods_no))
                                      ])
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1214408349
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "款号", align: "center", width: "130" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    on: {
                                      focus: function($event) {
                                        _vm.old_kh = scope.row.goods_kh
                                      },
                                      blur: function($event) {
                                        return _vm.changeKh(scope.row)
                                      }
                                    },
                                    model: {
                                      value: scope.row.goods_kh,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "goods_kh", $$v)
                                      },
                                      expression: "scope.row.goods_kh"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2330179031
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "代采单价",
                          prop: "plan_price",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.plan_price) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "strike",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.remove_price,
                                          expression: "scope.row.remove_price"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.remove_price) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2065406131
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "颜色",
                          prop: "co_val",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "尺码",
                          prop: "si_val",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "选择断货",
                          prop: "co_val",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 0,
                                          max:
                                            scope.row.plan_num -
                                            scope.row.cg_num -
                                            scope.row.temp_stop_num,
                                          size: "small"
                                        },
                                        model: {
                                          value: scope.row.stop_num,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "stop_num", $$v)
                                          },
                                          expression: "scope.row.stop_num"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2271207244
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "剩余数量",
                          prop: "plan_num",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.tapStopTableLeftNum(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.calcLeftNum(scope.row)) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          534153467
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", [
                                    _c("div", [_vm._v("断货")]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.calcGoodsStopNum(scope.row)
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1234699119
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "space-between span-top yellow-background" },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.resetStopNum }
                            },
                            [_vm._v("\n            重置数量")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.allStopNum }
                            },
                            [_vm._v("\n            全选")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n          实付金额合计：共" +
                            _vm._s(_vm.calcTotalMap.total_goods) +
                            "款，" +
                            _vm._s(_vm.calcTotalMap.total_num) +
                            "件，记¥" +
                            _vm._s(_vm.calcTotalMap.total_price) +
                            "\n        "
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.not_planid
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: _vm.tabs[2].key,
                    label: _vm.tabs[2].name + "(" + _vm.stock_goods + ")"
                  }
                },
                [
                  _c("stock-out-goods", {
                    ref: "stockOutGoodsRef",
                    attrs: {
                      pgid: Number(_vm.routeParams.pgid),
                      supply_id: Number(_vm.routeParams.supply_id)
                    },
                    on: { setNum: _vm.setStockNum }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.activityGoodsInfo.length > 0 || _vm.isCutActivityGoods === false
        ? _c(
            "div",
            [
              _c("div", { staticClass: "grey-bar span-top activity-title" }, [
                _c("div", [_vm._v("活动费商品抵扣")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        是否扣取活动费商品：\n        "),
                    _c("el-switch", {
                      on: { change: _vm.handleDealGoodsInfo },
                      model: {
                        value: _vm.isCutActivityGoods,
                        callback: function($$v) {
                          _vm.isCutActivityGoods = $$v
                        },
                        expression: "isCutActivityGoods"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.activityGoodsInfo, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "活动时间",
                      prop: "activity_time",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "商品名称",
                      prop: "goods_name",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "货号", prop: "goods_no", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "颜色/尺码",
                      prop: "co_si",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "SKU编号", prop: "sku", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "单件优惠额",
                      prop: "activity_fee",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "抵扣数量", prop: "num", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "订单ID",
                      prop: "order_id",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "活动ID",
                      prop: "activity_id",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "活动类型",
                      prop: "activity_type_text",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "活动名称",
                      prop: "activity_name",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "活动费抵扣小计",
                      prop: "activity_fee_amount",
                      align: "center"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-row-reverse span-top yellow-background" },
                [
                  _c("div", [
                    _vm._v(
                      "活动商品抵扣费用合计：¥" +
                        _vm._s(_vm.activity_fee_amount)
                    )
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.routeParams.settle_type == 1
        ? _c(
            "div",
            [
              (_vm.rebateData.list.length > 0 &&
                _vm.rebateData.total_ded > 0) ||
              _vm.openReturnProfitDed === false
                ? [
                    _c("div", { staticClass: "grey-bar span-top flex-row" }, [
                      _c("span", [_vm._v("让利佣金账单抵扣明细")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm._v("\n          是否使用让利抵扣：\n          "),
                          _c("el-switch", {
                            attrs: {
                              "active-text": "开启",
                              "inactive-text": "关闭"
                            },
                            on: { change: _vm.handleProfitSwitchChange },
                            model: {
                              value: _vm.openReturnProfitDed,
                              callback: function($$v) {
                                _vm.openReturnProfitDed = $$v
                              },
                              expression: "openReturnProfitDed"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      { attrs: { data: _vm.rebateData.list, border: "" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "让利账期",
                            prop: "reporting_period",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "让利账单编号",
                            prop: "bill_no",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "让利账单确认时间",
                            prop: "confirm_time",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "总结算金额",
                            prop: "amount_price",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "已抵扣金额",
                            prop: "already_ded_price",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "本单抵扣金额",
                            prop: "ded_price",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "剩余可抵扣",
                            prop: "remaining_ded_price",
                            align: "center"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "grey-bar span-top",
                        staticStyle: { "text-align": "right", color: "#f56c6c" }
                      },
                      [
                        _vm._v(
                          "\n        合计让利佣金抵扣金额：¥" +
                            _vm._s(_vm.rebateData.total_ded || "0.00") +
                            "\n      "
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "grey-bar span-top" }, [
                _vm._v("开单信息")
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.kdInfo(), border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "交易方式",
                      prop: "cg_type",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  !_vm.billing_info.is_sample_plan
                    ? _c("el-table-column", {
                        attrs: { label: "开单方式", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("div", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              value: "1",
                                              label: "1",
                                              size: "small"
                                            },
                                            model: {
                                              value: _vm.kd_form.order_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.kd_form,
                                                  "order_type",
                                                  $$v
                                                )
                                              },
                                              expression: "kd_form.order_type"
                                            }
                                          },
                                          [_vm._v("实数单")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              value: "2",
                                              label: "2",
                                              size: "small"
                                            },
                                            model: {
                                              value: _vm.kd_form.order_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.kd_form,
                                                  "order_type",
                                                  $$v
                                                )
                                              },
                                              expression: "kd_form.order_type"
                                            }
                                          },
                                          [_vm._v("排单单")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3467717267
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.billing_info.is_sample_plan
                    ? _c("el-table-column", {
                        attrs: {
                          label: "排单承诺回货日期",
                          align: "center",
                          width: "150"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "140px" },
                                        attrs: {
                                          type: "date",
                                          size: "small",
                                          "value-format": "yyyy-MM-dd",
                                          placeholder: "选择日期"
                                        },
                                        model: {
                                          value: _vm.kd_form.order_return_day,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.kd_form,
                                              "order_return_day",
                                              $$v
                                            )
                                          },
                                          expression: "kd_form.order_return_day"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          267385807
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "开单价合计",
                      prop: "total",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "活动服务费合计",
                      prop: "activity_fee",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label:
                        "平台佣金合计(" +
                        _vm.billing_info.service_fee_rate +
                        ")",
                      prop: "service_fee",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "store_fee",
                      label: "小店佣金",
                      "show-overflow-tooltip": "",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label:
                        "退货服务费合计(" +
                        _vm.billing_info.refund_fee_rate +
                        ")",
                      prop: "refund_fee",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "实付金额合计",
                      prop: "total_price",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商品抵扣", align: "center", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("div", { staticClass: "center" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.deductPrice) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.isAutoDeduct && _vm.isDeductPlan
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-left": "8px" } },
                                      [
                                        _vm.not_planid
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "small"
                                                },
                                                on: { click: _vm.selectDedData }
                                              },
                                              [_vm._v("选择商品抵扣")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1126850151
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "活动费商品抵扣", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.activity_fee_amount) +
                                    "\n          "
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2868879344
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "让利佣金抵扣金额",
                      align: "center",
                      prop: "total_ded"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    { attrs: { label: "实际结算金额", align: "center" } },
                    [
                      [
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.deductRebatePayPrice) +
                              "\n          "
                          )
                        ])
                      ]
                    ],
                    2
                  )
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.billing_info.pay_tool != 2
        ? _c(
            "div",
            [
              _c("div", { staticClass: "grey-bar span-top" }, [
                _vm._v("收款人信息")
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.billing_info.supply_payee, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "选择", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: scope.$index },
                                      model: {
                                        value: _vm.choice_payee,
                                        callback: function($$v) {
                                          _vm.choice_payee = $$v
                                        },
                                        expression: "choice_payee"
                                      }
                                    },
                                    [_vm._v("\n               ")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1075562453
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "payee_name",
                      label: "收款人名称",
                      "show-overflow-tooltip": "",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "payee_bank",
                      label: "收款人银行",
                      "show-overflow-tooltip": "",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cnap_name",
                      label: "收款人银行支行",
                      "show-overflow-tooltip": "",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "payee_bank_account",
                      label: "收款账号",
                      "show-overflow-tooltip": "",
                      align: "center"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "space-between span-top",
          staticStyle: { "align-items": "flex-end" }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "90%" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "填写备注", rows: "3" },
                model: {
                  value: _vm.kd_form.note,
                  callback: function($$v) {
                    _vm.$set(_vm.kd_form, "note", $$v)
                  },
                  expression: "kd_form.note"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("提交开单")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("kd-dialog", {
        ref: "kdDialogRef",
        on: { confirm: _vm.confirmDkNum }
      }),
      _vm._v(" "),
      _c("multi-phase-goods", { ref: "multiPhaseGoodsRef" }),
      _vm._v(" "),
      _c("ded-table", {
        ref: "dedTableRef",
        on: { "on-confirm": _vm.handleDeductGoodsConfirm }
      }),
      _vm._v(" "),
      _c("billing-detail", { ref: "billingDetailRef" }),
      _vm._v(" "),
      _vm.isAutoDeduct && _vm.isDeductPlan
        ? _c(
            "div",
            [
              _c("div", { staticClass: "grey-bar" }, [
                _vm._v(
                  "\n      抵扣商品明细（汇总：共" +
                    _vm._s(_vm.result.total_num) +
                    "件，抵扣金额 ¥\n      " +
                    _vm._s(_vm.result.total_amount) +
                    "）\n    "
                )
              ]),
              _vm._v(" "),
              _c("YsDataTable", {
                attrs: {
                  "init-params": {
                    supply_id: _vm.routeParams.supply_id,
                    price: _vm.kdInfo()[0].total_price
                  },
                  "fetch-method": _vm.fetchMethod,
                  columns: _vm.columns,
                  "use-pagination": false,
                  "max-height": "400",
                  "use-data-field": ""
                },
                on: { "on-fetch-success": _vm.handleFetchSuccess },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "goods_img",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "40px",
                                height: "40px",
                                overflow: "hidden",
                                cursor: "pointer",
                                margin: "auto"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleViewImages(row.imgs)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "100%", height: "100%" },
                                attrs: { src: row.goods_img }
                              })
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  193268655
                ),
                model: {
                  value: _vm.refresh,
                  callback: function($$v) {
                    _vm.refresh = $$v
                  },
                  expression: "refresh"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38f953a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f953a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchaseverify/WaitingPurchaseDetail.vue
// module id = null
// module chunks = 